import { render, staticRenderFns } from "./pre_base_tan_step.vue?vue&type=template&id=6ea2c8c8&scoped=true"
import script from "./pre_base_tan_step.vue?vue&type=script&lang=js"
export * from "./pre_base_tan_step.vue?vue&type=script&lang=js"
import style0 from "./pre_base_tan_step.vue?vue&type=style&index=0&id=6ea2c8c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea2c8c8",
  null
  
)

export default component.exports